<div class="flex flex-col gap-2">
  <!-- Value display (optional) -->
  @if (showValue()) {
    <div class="flex justify-end">
      <span [class]="valueLabelClasses()">{{ value() }}</span>
    </div>
  }

  <!-- Slider container -->
  <div class="relative flex items-center">
    <!-- Min label (optional) -->
    @if (showMinMax()) {
      <span [class]="'mr-2 ' + minMaxClasses()">{{ min() }}</span>
    }

    <!-- Track -->
    <div
      #track
      [class]="trackClasses()"
      (click)="onTrackClick($event)"
    >
      <!-- Fill -->
      <div
        [class]="fillClasses()"
        [style.width.%]="percentage()"
      ></div>

      <!-- Thumb -->
      <button
        type="button"
        role="slider"
        [attr.aria-valuemin]="min()"
        [attr.aria-valuemax]="max()"
        [attr.aria-valuenow]="value()"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-labelledby]="ariaLabelledBy()"
        [attr.aria-describedby]="ariaDescribedBy()"
        [attr.id]="id()"
        [attr.name]="name()"
        [disabled]="disabled()"
        [class]="thumbClasses()"
        [style.left.%]="percentage()"
        (mousedown)="onThumbMouseDown($event)"
        (keydown)="onKeyDown($event)"
      ></button>
    </div>

    <!-- Max label (optional) -->
    @if (showMinMax()) {
      <span [class]="'ml-2 ' + minMaxClasses()">{{ max() }}</span>
    }
  </div>
</div>
